import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { _className, ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import './AdvisorColumn.scss';
import { ColumnKey_LeftColumn, ColumnKey_MiddleColumn, ColumnKey_RightColumn, FloatingColumns } from '@app/advisor-v5-shared';
import { AdvisorPanelResizer } from '../AdvisorPanelResizer/AdvisorPanelResizer.js';
import { PanelKeyToRenderer } from '../../../consts.js';
import { _keys, reduceToMap, sortArray } from '@nu-art/ts-common';
import { dispatch_onAdvisorBoardTransitionEnd, ModuleFE_AdvisorBoard } from '../../../_enum/advisor-board/index.js';
const columnOrder = [ColumnKey_LeftColumn, ColumnKey_MiddleColumn, ColumnKey_RightColumn];
export class AdvisorColumn extends ComponentSync {
    columnRef = React.createRef();
    __onAdvisorBoardUpdated(updates) {
        if (!updates.includes(this.props.columnKey))
            return;
        const width = ModuleFE_AdvisorBoard.getColumnWidth(this.props.columnKey);
        const columnItems = ModuleFE_AdvisorBoard.getColumnItems(this.props.columnKey);
        const columnStyle = { width };
        const panelHeights = this.getPanelHeights(this.state.columnKey, columnItems);
        this.setState({
            style: columnStyle,
            panelHeights: panelHeights,
            items: columnItems
        });
    }
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.columnKey = nextProps.columnKey;
        state.items = ModuleFE_AdvisorBoard.getColumnItems(nextProps.columnKey);
        //Re-calc panel heights when the column key changes
        if (state.columnKey !== this.state?.columnKey)
            state.panelHeights = this.getPanelHeights(state.columnKey, state.items);
        return state;
    }
    componentDidMount() {
        // when the board is first rendered, we need to dispatch the transition end event
        setTimeout(() => dispatch_onAdvisorBoardTransitionEnd.dispatchUI(this.props.columnKey), 300);
    }
    //######################### Logic #########################
    getPanelHeights(columnKey, columnItems) {
        return reduceToMap(columnItems, item => item.panelKey, item => ModuleFE_AdvisorBoard.getItemHeight(columnKey, item.panelKey));
    }
    getClassName = () => {
        const extraPaddings = this.extraPaddings();
        return _className('page-advisor__column', extraPaddings?.left && 'extra-padding-left', extraPaddings?.right && 'extra-padding-right', this.props.columnKey // add a special css treatment for floating panels
        );
    };
    getResizerProps = (panelKey) => {
        const actualItems = this.state.items.filter(item => item.height > 0);
        const calculatedHeight = this.state.panelHeights?.[panelKey];
        if (!calculatedHeight)
            return { height: 0, paddingBottom: 0, paddingTop: 0 };
        const resizerProps = { paddingBottom: 8, paddingTop: 8 };
        resizerProps.height = calculatedHeight + 16;
        const index = actualItems.findIndex(item => item.panelKey === panelKey);
        if (index === 0) {
            resizerProps.paddingTop = 0;
            resizerProps.height -= 8;
        }
        if (index === actualItems.length - 1) {
            resizerProps.paddingBottom = 0;
            resizerProps.height -= 8;
        }
        return resizerProps;
    };
    extraPaddings = () => {
        const extraPadding = { left: false, right: false };
        const board = ModuleFE_AdvisorBoard.getBoard();
        let columns = _keys(board).map(key => ({ key, width: board[key].width }));
        sortArray(columns, col => columnOrder.indexOf(col.key));
        //Filter out hidden or floating columns in this calculation
        columns = columns.filter(col => {
            if (col.width <= 0 || FloatingColumns.includes(col.key))
                return false;
        });
        const index = columns.findIndex(col => col.key === this.state.columnKey);
        if (index === 0)
            extraPadding.left = true;
        if (index === columns.length - 1)
            extraPadding.right = true;
        return extraPadding;
    };
    onTransitionEnd = (e) => {
        if (!this.columnRef.current)
            return;
        if (e.target !== this.columnRef.current)
            return;
        dispatch_onAdvisorBoardTransitionEnd.dispatchUI(this.props.columnKey);
    };
    //######################### Render #########################
    render() {
        if (!this.state.items?.length)
            return;
        return _jsx(LL_V_L, { innerRef: this.columnRef, style: this.state.style, className: this.getClassName(), onTransitionEnd: this.onTransitionEnd, children: this.state.items.map(item => {
                const Renderer = PanelKeyToRenderer[item.panelKey];
                const resizerProps = this.getResizerProps(item.panelKey);
                return _jsx(AdvisorPanelResizer, { height: resizerProps.height, paddingTop: resizerProps.paddingTop, paddingBottom: resizerProps.paddingBottom, children: _jsx(Renderer, { context: FloatingColumns.includes(this.props.columnKey) ? 'floating' : undefined, panelHeight: this.state.panelHeights?.[item.panelKey] ?? 0 }) }, item.panelKey);
            }) });
    }
}
//# sourceMappingURL=AdvisorColumn.js.map